// extracted by mini-css-extract-plugin
export default {"mainContainer":"FlexCard_mainContainer__762tw","title":"FlexCard_title__syoOs"};